// ** Icons Import
import {DollarSign, Circle } from 'react-feather'

export default [
    {
        id: 'transactions',
        title: 'Транзакции',
        icon: <DollarSign size={18} />,
        //badge: 'light-warning',
        //badgeText: '2',
        children: [
            {
                id: 'transactions_list',
                title: 'Список транзакций',
                icon: <Circle size={6} />,
                navLink: '/transactions/'
            },
            {
                id: 'notifications',
                title: 'Уведомления',
                icon: <Circle size={6} />,
                navLink: '/notifications/'
            }
        ]
    }
]
